import researcherSignup, {
  namespace as researcherNamespace,
} from './researcherSignup';
import notifications, {
  namespace as notificationsNamespace,
} from './notifications';
import referral, { namespace as referralNamespace } from './referral';

export default {
  [researcherNamespace]: researcherSignup,
  [notificationsNamespace]: notifications,
  [referralNamespace]: referral,
};
